import { FIND_ABSENT, FIND_USER } from "../../routes";
import customAxios from "../../customAxios";
import { IFindUserInformation } from "../../../types/common.interface";
import utils from "../../../utils";

async function findDriver(props: IFindUserInformation) {
  var thisUrl = FIND_ABSENT + "?";
  if (props.page) thisUrl += `page=${props.page}`;
  if (props.limit) thisUrl += `&limit=${props.limit}`;

  //   const populateFields =
  //     "blocks financial schoolDriverInformation companyInformation driverInformation.city driverInformation.province driverInformation.plateNumber driverInformation.financialGroup gender driverInformation.subscriptionExpireAt driverInformation.nationalCode driverInformation.driverLicenseNumber driverInformation.insuranceNumber driverInformation.address driverInformation.uniqueCodeThirdPartyInsurance driverInformation.approved driverInformation.carBrand driverInformation.carModel driverInformation.carColor driverInformation.carSystem driverInformation.insuranceExpiryDate driverInformation.vin avatar";

  //   thisUrl += `&populate=${populateFields}`;

  //   let schoolDriverInformation;
  //   if (props.companyId) {
  //     schoolDriverInformation = {
  //       "schoolDriverInformation.company": props.companyId,
  //     };
  //   }

  let body: any = {};

  // ** ---------------------------------------------------------------------------------------------------------------------
  // ** =====================================================================================================================
  // **                                                      Local Functions
  // ** =====================================================================================================================
  // ** ---------------------------------------------------------------------------------------------------------------------

  // ?? ---------------------------------------------------------------------------------------------------------------------
  // ?? =====================================================================================================================
  // ??                                            Searching For SuperAgent
  // ?? =====================================================================================================================
  // ?? ---------------------------------------------------------------------------------------------------------------------

  // if (props?.search?.value) {
  //   body = {
  //     query: {
  //       ...body.query,
  //       [String(props.search.base)]: utils.convertNumbers2English(
  //         props.search.value
  //       ),
  //     },
  //   };
  // }

  // ?? ---------------------------------------------------------------------------------------------------------------------
  // ?? =====================================================================================================================
  // ??                                                    Filtering For SuperAgent
  // ?? =====================================================================================================================
  // ?? ---------------------------------------------------------------------------------------------------------------------
  if (props?.filters) {
    const {
      student,
      company,
      driver,
      superAgent,
      parent,
      school,
      absentType,
      statusInService,
      isChecked,
    } = props.filters;

    body = {
      ...body,
      student: student?._id,
      company: company?._id,
      driver: driver?._id,
      superAgent: superAgent?._id,
      parent: parent?._id,
      school: school?._id,
      absentType: absentType,
      statusInService: statusInService,
      isChecked: isChecked,
    };
  }

  // ?? Academic year (سال تحصیلی) scope, set last so the branches above cannot drop it.
  if (props.academicYear) body.academicYear = props.academicYear;

  try {
    return (await customAxios.post(thisUrl, body)).data;
  } catch (error: any) {
    console.error({ GET_ALL_COMPANY: error });
  }
}

export default findDriver;
